(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("$rdf"));
	else if(typeof define === 'function' && define.amd)
		define("SolidLogic", ["$rdf"], factory);
	else if(typeof exports === 'object')
		exports["SolidLogic"] = factory(require("$rdf"));
	else
		root["SolidLogic"] = factory(root["$rdf"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__264__) => {
return 